import React from 'react'

export const BroadCastIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.555176 5.26666H12.2885V13.8H0.555176V5.26666Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2886 11.1334L15.8349 12.4631C15.9154 12.4933 16.0021 12.5035 16.0874 12.493C16.1728 12.4824 16.2543 12.4513 16.3251 12.4024C16.3959 12.3535 16.4538 12.2883 16.4938 12.2121C16.5339 12.136 16.555 12.0514 16.5552 11.9654V7.10278C16.555 7.01677 16.5339 6.9321 16.4938 6.85599C16.4538 6.77989 16.3959 6.7146 16.3251 6.6657C16.2543 6.61681 16.1728 6.58575 16.0874 6.57518C16.0021 6.56461 15.9154 6.57484 15.8349 6.605L12.2886 7.93336V11.1334Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.68848 9.79998C2.68848 10.1536 2.82895 10.4927 3.079 10.7428C3.32905 10.9928 3.66819 11.1333 4.02181 11.1333C4.37543 11.1333 4.71457 10.9928 4.96462 10.7428C5.21467 10.4927 5.35514 10.1536 5.35514 9.79998C5.35514 9.44636 5.21467 9.10722 4.96462 8.85717C4.71457 8.60712 4.37543 8.46664 4.02181 8.46664C3.66819 8.46664 3.32905 8.60712 3.079 8.85717C2.82895 9.10722 2.68848 9.44636 2.68848 9.79998V9.79998Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.48853 9.79998C7.48853 10.1536 7.629 10.4927 7.87905 10.7428C8.1291 10.9928 8.46824 11.1333 8.82186 11.1333C9.17548 11.1333 9.51462 10.9928 9.76467 10.7428C10.0147 10.4927 10.1552 10.1536 10.1552 9.79998C10.1552 9.44636 10.0147 9.10722 9.76467 8.85717C9.51462 8.60712 9.17548 8.46664 8.82186 8.46664C8.46824 8.46664 8.1291 8.60712 7.87905 8.85717C7.629 9.10722 7.48853 9.44636 7.48853 9.79998V9.79998Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.02197 8.46664H8.82197"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4886 1H11.7553C11.6138 1 11.4782 1.05619 11.3781 1.15621C11.2781 1.25623 11.2219 1.39188 11.2219 1.53333V2.6C11.2219 2.74145 11.2781 2.8771 11.3781 2.97712C11.4782 3.07714 11.6138 3.13333 11.7553 3.13333H15.4886C15.7715 3.13333 16.0428 3.02095 16.2428 2.82091C16.4429 2.62087 16.5553 2.34956 16.5553 2.06667C16.5553 1.78377 16.4429 1.51246 16.2428 1.31242C16.0428 1.11238 15.7715 1 15.4886 1Z"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2217 2.06665H10.155C9.87215 2.06665 9.60084 2.17903 9.4008 2.37907C9.20076 2.57911 9.08838 2.85042 9.08838 3.13332V5.26665"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.08838 3.13336H5.35505C5.63794 3.13336 5.90925 3.24574 6.10929 3.44578C6.30933 3.64582 6.42171 3.91713 6.42171 4.20003V5.2667"
      stroke="#6B6B6B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
